import client from './client';

export const routinesApi = {
  getAll: (params) => client.get('/routines', { params }),
  getById: (id) => client.get(`/routines/${id}`),
  create: (data) => client.post('/routines', data),
  update: (id, data, sessionId) => client.put(`/routines/${id}${sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : ''}`, data),
  delete: (id) => client.delete(`/routines/${id}`),
  toggleShare: (id) => client.patch(`/routines/${id}/share`),

  // Public share page
  getPublic: (id) => client.get(`/routines/public/${id}`),
  saveShared: (id) => client.post(`/routines/public/${id}/save`),

  // Version history
  listVersions: (id) => client.get(`/routines/${id}/versions`),
  getVersion: (id, n) => client.get(`/routines/${id}/versions/${n}`),
  restoreVersion: (id, n) => client.post(`/routines/${id}/versions/${n}/restore`),

  // Recently deleted
  listDeleted: () => client.get('/routines/deleted'),
  restoreDeleted: (id) => client.post(`/routines/deleted/${id}/restore`),
};
